import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./LandingPage";
import Login from "./Login";
import AuthCallback from "./AuthCallback";
import AuthSuccess from "./AuthSuccess";
import Dashboard from "./Dashboard";
import ContactPage from "./ContactPage";
import AdminLibrary from "./AdminLibrary";
import HomeCollectionConfirmed from "./HomeCollectionConfirmed";
import WantedListPage from "./WantedListPage";
import MatchesPage from "./MatchesPage";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";
import CommunityGuidelines from "./CommunityGuidelines";
import BatchCheckerPage from "./BatchCheckerPage";
import ScreenshotImportPage from "./ScreenshotImportPage";
import { HelpCenterPage, HelpArticlePage } from "./HelpPages";
import { VerifyEmailPage, ResetPasswordPage } from "./AuthPages";

// Router component to handle session_id detection
function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id in URL fragment BEFORE routing
  // This prevents race conditions by processing auth callback first
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth-success" element={<AuthSuccess />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/admin" element={<AdminLibrary />} />
      <Route path="/wanted-list" element={<WantedListPage />} />
      <Route path="/matches" element={<MatchesPage />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/community-guidelines" element={<CommunityGuidelines />} />
      <Route path="/batch" element={<BatchCheckerPage />} />
      <Route path="/screenshot-import" element={<ScreenshotImportPage />} />
      <Route path="/help" element={<HelpCenterPage />} />
      <Route path="/help/:slug" element={<HelpArticlePage />} />
      <Route path="/home-collection/confirmed" element={<HomeCollectionConfirmed />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
